class KCVS.Views.ReportDocumentIndexView extends Backbone.View
  initialize: ->
    if $('*[data-popload]')[0]
      $('*[data-popload]').hoverIntent @quickFilePreview, @closeFilePreview, timeout: 1000
      $(document).on 'click', @closeFilePreview

  quickFilePreview: (e) ->
    e = $(this)
    attr = e.attr('aria-describedby')
    unless (typeof attr != typeof undefined && attr != false)
      if (e.parent().hasClass('pdf') || e.parent().hasClass('png') || e.parent().hasClass('jpg'))
        e.off 'hover'
        $.get e.data('popload'), (d) ->
          e.popover(content: d, html: true, container: e, sanitize: false).popover 'show'
          return

  closeFilePreview: (e) ->
    $('[data-original-title]').popover 'hide'
